export default "__VITE_ASSET__CDb5KC57__";